<template>
    <div style="position: relative; z-index: 1;" onclick="event.stopPropagation();">
        <div style="position: relative; top: 0; left: 0;">
          <button :class="computedClasses" v-on:click.prevent="showOptions = true" id="sortbutton" :style="{}">
                    <span  v-show="screenSizeId >= 3" class="d-flex flex-nowrap">
                        Sort <i class="fas fa-caret-down"></i>
                    </span>
            <span v-show="screenSizeId < 3"><i class="fas fa-sort-amount-down"></i></span>
          </button>
            <div v-show="showOptions"
                 :class="{'large': screenSizeId >= 3, 'small': screenSizeId < 3}"
                 id="multiselect">
              <div class="d-flex flex-row"> <!---->
                <div style="width: 90px !important; border: 1px solid lightgray;" class="d-flex flex-row justify-content-center align-items-center" v-if="screenSizeId >= 3">
                  <span class="pr-1">{{firstSort.name}}</span>
                  <span v-if="!firstSort.value" style="color: lightgray;">First</span>
                  <span v-show="firstSort.asc && firstSort.value"><i class="fas fa-long-arrow-alt-up"></i></span>
                  <span v-show="!firstSort.asc && firstSort.value"><i class="fas fa-long-arrow-alt-down"></i></span>
                </div>
                <div style="width: 90px !important; border: 1px solid lightgray;" class="d-flex flex-row justify-content-center align-items-center" v-if="screenSizeId >= 3">
                  <span class="pr-1">{{secondSort.name}}</span>
                  <span v-if="!secondSort.value" style="color: lightgray;">Second</span>
                  <span v-show="secondSort.asc && secondSort.value"><i class="fas fa-long-arrow-alt-up"></i></span>
                  <span v-show="!secondSort.asc && secondSort.value"><i class="fas fa-long-arrow-alt-down"></i></span>
                </div>
                <div style="width: 90px !important; border: 1px solid lightgray;" class="d-flex flex-row justify-content-center align-items-center" v-if="screenSizeId >= 3">
                  <span class="pr-1">{{thirdSort.name}}</span>
                  <span v-if="!thirdSort.value" style="color: lightgray;">Third</span>
                  <span v-show="thirdSort.asc && thirdSort.value"><i class="fas fa-long-arrow-alt-up"></i></span>
                  <span v-show="!thirdSort.asc && thirdSort.value"><i class="fas fa-long-arrow-alt-down"></i></span>
                </div>

              </div>
                <div style="position: relative; border-bottom: 1px solid lightgray; padding-top: 2px;">
                    <div class="btn-link" style="position: absolute; top: 10px; right: 10px;" @click="clear()">Clear
                    </div>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active pointer" data-toggle="tab" data-target="#sort1">First</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link pointer" data-toggle="tab" data-target="#sort2">Second</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link pointer" data-toggle="tab" data-target="#sort3">Third</a>
                        </li>
                    </ul>

                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane container active" id="sort1">
                            <a
                                    href="#" v-for="(option, index) in options"
                                    :value="option.value"
                                    :class="{'gray':option.value != firstSort.value}"
                            >
                                <div style="padding: 2px;" v-on:click="firstSort.asc = !firstSort.asc">
                                    <span v-on:click="firstSort = option" style="width: 100%">{{option.name}}</span>
                                    <span class="float-right">
                                        <span :class="{'lightgray':option.value != firstSort.value || firstSort.asc}" class="mr-1"><i class="fas fa-long-arrow-alt-down"></i></span>
                                        <span :class="{'lightgray': option.value != firstSort.value || !firstSort.asc}"><i class="fas fa-long-arrow-alt-up"></i></span>
                                    </span>
                                </div>

                            </a>
                        </div>
                        <div class="tab-pane container fade" id="sort2">
                            <a
                                    href="#" v-for="(option, index) in options"
                                    :value="option.value"
                                    v-on:click="secondSort = option, secondSortAsc = !secondSortAsc"
                                    :class="{'gray':option.value != secondSort.value}"
                            >


                                <div style="padding: 2px;" v-on:click="secondSort.asc = !secondSort.asc" >
                                    <span v-on:click="secondSort = option" style="width: 100%">{{option.name}}</span>
                                    <span class="float-right">
                                        <span :class="{'lightgray':option.value != secondSort.value || secondSort.asc}" class="mr-1"><i class="fas fa-long-arrow-alt-down"></i></span>
                                        <span :class="{'lightgray': option.value != secondSort.value || !secondSort.asc}"><i class="fas fa-long-arrow-alt-up"></i></span>
                                    </span>
                                </div>

                            </a>
                        </div>
                        <div class="tab-pane container fade" id="sort3">
                            <a
                                    href="#" v-for="(option, index) in options"
                                    :value="option.value"
                                    v-on:click="thirdSort = option, thirdSortAsc = !thirdSortAsc"
                                    :class="{'gray':option.value != thirdSort.value}"
                            >
                                <div style="padding: 2px;" v-on:click="thirdSort.asc = !thirdSort.asc">
                                    <span v-on:click="thirdSort = option" style="width: 100%">{{option.name}}</span>
                                    <span class="float-right">
                                        <span :class="{'lightgray':option.value != thirdSort.value || thirdSort.asc}" class="mr-1"><i class="fas fa-long-arrow-alt-down"></i></span>
                                        <span :class="{'lightgray': option.value != thirdSort.value || !thirdSort.asc}"><i class="fas fa-long-arrow-alt-up"></i></span>
                                    </span>
                                </div>

                            </a>
                        </div>
                    </div>
                </div>
                <div style="width: 100%" class="d-flex flex-row justify-content-end">
                    <button @click="cancel()" class="btn btn-secondary" style="margin: 5px;">Cancel</button>
                    <button @click="onChange()" class="btn btn-primary" style="margin: 5px;">Go</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        /**
            tag
            name: ks-multi-sort
            description: multi sort
        **/
        name: 'multi-sort',
        props: {
            /**
                attribute
                name: dataProvider 
                description: dataProvider
            **/
            dataProvider: {
                required: true,
                default: null
            },
            /**
                attribute
                name: options 
                description: options
            **/
            options: {
                type: Array,
                default: () => []
            },
            /**
                attribute
                name: buttonClass 
                description: buttonClass
            **/
            buttonClass: {
                default: "btn btn-primary"
            }
        },
        watch: {},
        mounted() {
            document.addEventListener('click', this.documentClicked);
            $(".nav-tabs a").click(function () {
                $(this).tab('show');
            });
            this.setSort();

        },
        computed: {
            screenSizeId() {
                return app.layout.screenSizeId;
            },
          computedClasses() {
              let returnVal = this.buttonClass;
              returnVal += this.screenSizeId >= 3 ? " big-margin" : "";
              return returnVal;
          }
        },
        methods: {
            setSort() {
                setTimeout(() => {
                    let order_by = this.dataProvidersRef[this.dataProvider].order_by;
                    let newSort = [];
                    if (order_by) {
                        let array1 = order_by.split(',');
                        array1.forEach((item, index) => {
                            let array2 = item.split(" ");
                            newSort.push({"value": array2[0], "asc": array2[1] == 'ASC'})
                        });
                    }
                    if (newSort[0]) {
                        this.firstSort = this.options.find(option => option.value == newSort[0].value);
                        this.firstSort.asc = newSort[0].asc;
                    }
                    if (newSort[1]) {
                        this.secondSort = this.options.find(option => option.value == newSort[1].value);
                        this.secondSort.asc = newSort[1].asc;
                    }
                    if (newSort[2]) {
                        this.thirdSort = this.options.find(option => option.value == newSort[2].value);
                        this.thirdSort.asc = newSort[2].asc;
                    }
                }, 300);
            },
            clear() {
                this.firstSort = {};
                this.secondSort = {};
                this.thirdSort = {};
                this.onChange();
            },
            cancel() {
                this.setSort();
            },
            onChange() {
                let firstSortDirection = this.firstSort.asc ? " asc" : " desc";
                let secondSortDirection = this.secondSort.asc ? " asc" : " desc";
                let thirdSortDirection = this.thirdSort.asc ? " asc" : " desc";
                let addFirstComma = this.firstSort.value ? "," : "";
                let addSecondComma = this.firstSort.value || this.secondSort.value ? "," : "";
                let sortOptionOne = this.firstSort.value ? this.firstSort.value + firstSortDirection : "";
                let sortOptionTwo = this.secondSort.value ? addFirstComma + this.secondSort.value + secondSortDirection : "";
                let sortOptionThree = this.thirdSort.value ? addSecondComma + this.thirdSort.value + thirdSortDirection : "";
                let sortOptions = sortOptionOne + sortOptionTwo + sortOptionThree;
                this.$parent.data_provider_ref.set_order(sortOptions);
                this.$emit('onChange');
                this.showOptions = false;
            },
            documentClicked(event) {
                if (event.target.id !== 'sortbutton') {
                    this.showOptions = false;
                }
            },
        },
        data() {
            return {
                input: "",
                firstSort: {},
                firstSortAsc: false,
                secondSort: {},
                secondSortAsc: false,
                thirdSort: {},
                thirdSortAsc: false,
                showOptions: false,
                sortOne: "",
                sortTwo: "",
                sortThree: "",
                data_provider_ref: {},
                dataProvidersRef: app.dataproviders
            }
        },
        destroyed: function () {
            document.removeEventListener('click', this.documentClicked)
        },
    }
</script>
<style scoped>
    .big-margin {
      margin-right: 270px;
    }
    a {
        color: red;
    }
    a:hover {
        color: darkred;
    }
    .lightgray {
        color: lightgray;
    }
    .gray {
        color: gray;
    }
    .large {
        position: absolute; top: 40px; left: 0; background: white; width: 380px; border: 2px solid lightgray; border-radius: 5px;
    }
    .small {
        position: fixed; top: 60px; left: 0; background: white; width: 100%; border: 2px solid lightgray; border-radius: 5px;
    }
</style>
